import { DisputeReportListItemData } from "./report-base";

export class DisputeReportUserListData extends DisputeReportListItemData {
  clubUserProgramFeeID: number;
  userID: number;
  paymentID: number;
  paymentAmount: number;
  disputedAmount: number;
  clubProgramID: number;

  firstName: string;
  lastName: string;
  avatar: string;
  feeName: string;
  status: string;
  reason: string;
  disputedID: string;

  paymentDate: Date;
  disputedDate: Date;
  respondByDate: Date;
}

export class UserDisputeReport {
  totalDisputeResponseNeeded: number;
  totalReviewCount: number;
  totalDisputeWon: number;
  totalDisputeLost: number;

  list: DisputeReportUserListData[];

  constructor(data: any = {}) {
    this.totalDisputeResponseNeeded = +data.totalResponseNeededCount;
    this.totalReviewCount = +data.totalReviewCount;
    this.totalDisputeWon = +data.totalWonDisputeCount;
    this.totalDisputeLost = +data.totalLostDisputeCount;

    this.list = data.stripeDisputeList
      ? data.stripeDisputeList.map(l => new DisputeReportUserListData(l))
      : [];
  }
}

export class UserDispute {
  private static stringKeys = [
    "firstname",
    "avatar",
    "group",
    "fee",
    "gender",
    "by",
    "type",
    "credit"
  ];

  firstname: string;
  avatar: string;
  date: Date;
  group: string;
  fee: string;
  gender: string;
  by: string;
  type: string;
  credit: number;

  constructor(data: any = {}) {
    UserDispute.stringKeys.forEach(key => (this[key] = data[key]));
    this.date = data.date ? new Date(data.date) : null;
  }
}

export class DisputeReport {
  list: UserDispute[];
  totalNumber: number;
  totalAmount: number;

  constructor(data: any = {}) {
    this.list = (data.disputeReportUserList || []).map(
      user => new UserDispute(user)
    );
    this.totalNumber = data.totalNumberOfDispute || 0;
    this.totalAmount = data.totalDisputeAmount || 0;
  }
}

export class DisputeSubmitData {
  userID: number;
  stripeDisputeID: string;
  refundInfoWhen: string;
  refundInfoWhy: string;
  productDescription: string;
  customerCommunicationUrl: string;
  additionalInfo: string;
  additionalInfoUrl: string;
}



// WEBPACK FOOTER //
// ./src/app/models/reports/dispute-report.ts